// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g8ck","index":"styles_index__71Apd"};